import React from 'react';

function HomePage() {
  return <div>Hello</div>;
}

export default HomePage;
